module.exports = "/packs/images/pages/membership/better_lido-tablet~b8cf953e9449d6f23e5d403fdaa23892.jpg";